import { createContext } from 'react';
var INITIAL_DATA = null;
export var HeaderDataContext = /*#__PURE__*/createContext(INITIAL_DATA);